import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Title from "../components/common/Title";
import { Postdata } from "../helpers/api.service";
import HttpService from "../helpers/httpServices";
import { message } from "../redux/actions/toastActions";
import Loader from "../components/common/Loader";
import Breadcrumb from "../components/common/Breadcrumb";
import Link from "../components/common/Link";
import "../styles/Profile.scss";
import { Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import ModalPopup from "../components/common/Modal";
import BoardNotes from "../components/Board-Management/BoardNotes";
import BoardFiles from "../components/Board-Management/BoardFiles";
import Contributions from "../components/Board-Management/Contributions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isRole, isRoleType } from "../redux/selectors/authSelector";
import { useCountryNavigate } from "../components/common/UseCountryNavigate";

const AddBoardManager = () => {
  const dispatch = useDispatch();
  const params = useParams();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [loader, setLoader] = useState(false);
  // const [matchIds, setMatchIds] = useState([])
  const [logo, setLogo] = useState("");
  // const [cmIds, setCMIds] = useState([])
  const [apiloader, setapiloader] = useState(false);
  const [coinloader, setcoinloader] = useState(false);
  // const [isSearchLoading, setIsSearchLoading] = useState(false)
  // const [isTypeSelected, setIsTypeSelected] = useState(false)
  // const [typeValue, settypeValue] = useState('')
  // const [targetlink, setTargetLink] = useState({ type: "", targetLink: "" })
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [modalData, setModalData] = useState({ platform: "", link: "" });
  const [modalChangeProfile, setmodalChangeProfile] = useState(false);
  const [key, setKey] = useState(
    window.sessionStorage.getItem("userTabs")
      ? window.sessionStorage.getItem("userTabs")
      : "user"
  );
  const mode = localStorage.getItem("mode");
  // const { id } = useParams();
  const schoolId = localStorage.getItem("activeSchoolId");
  // const [keysub, setKeysub] = useState(window.sessionStorage.getItem('detailsTabs') ? window.sessionStorage.getItem('detailsTabs') : 'details');
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  console.log("role=================", role);
  const [formdata, setFormdata] = useState({
    name: "",
    designation: "",
    bio: "",
    profile_img: "",
    social_media: [],
    notes: [],
    files: [],
    contribution: [],
    start_date: "",
    end_date: "",
    status: 1,
  });

  const onAddSchool = (event) => {
    event.preventDefault();
    setLoader(true);

    Postdata(HttpService.board_management_add, formdata).then((res) => {
      if (res.status === 200) {
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          navigate("navigation-dashboard");
        } else {
          navigate("board-management");
        }
      }
      dispatch(message(res.message));
    });
    setLoader(false);
  };

  const handleEditClick = (index) => {
    setEditIndex(index);
    setModalData(formdata.social_media[index]);
    setShowModal(true);
  };

  const handleModalSave = () => {
    const updated = [...formdata.social_media];
    updated[editIndex] = modalData;
    setFormdata({ ...formdata, social_media: updated });
    setShowModal(false);
  };

  const handleAddNew = () => {
    setFormdata({
      ...formdata,
      social_media: [...formdata?.social_media, { platform: "", link: "" }],
    });
  };

  const handleDeleteSocial = (index) => {
    const updated = [...formdata.social_media];
    updated.splice(index, 1);
    setFormdata({ ...formdata, social_media: updated });
  };
  const handleSelect = (key) => {
    if (key == 1) {
      navigate(`board-management/edit/${params.id}`);
    }
    if (key == 2) {
      navigate("contest/add");
    }
    if (key == 3) {
      navigate("request-management");
    }
    if (key == 4) {
      navigate("kyc");
    }
    if (key == 5) {
      navigate("subadmin-management");
    }
    if (key == 6) {
      navigate("match");
    }
    if (key == 7) {
      navigate("report/tds-management");
    }
    if (key == 8) {
      navigate("report/gstreport");
    }
  };

  async function fetchData(id) {
    const response = await Postdata(HttpService.board_management_show, {
      id: id,
    });
    if (response.status !== 200) {
      if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
        if (mode === "view") {
          navigate(`admin-school/view/${id}`, {
            state: { mainTab: "Board Management" },
          });
        } else {
          navigate("navigation-dashboard");
        }
      } else {
        navigate("board-management");
      }
    }
    console.log("response>>>>>>>>>>>>>>>", response);
    setLogo(response.data.profile_img);
    setapiloader(false);
    setFormdata({
      id: params.id,
      name: response.data.name,
      designation: response.data.designation,
      bio: response.data.bio,
      status: response.data.status,
      social_media: response.data.social_media || [],
      start_date: response.data.start_date
        ? response.data.start_date.split("T")[0]
        : "",
      end_date: response.data.end_date
        ? response.data.end_date.split("T")[0]
        : "",
    });
  }

  const onUpdateProfile = (event) => {
    event.preventDefault();
    setcoinloader(true);
    Postdata(HttpService.board_management_add, {
      id: params.id,
    })
      .then((response) => {
        if (response.status === 200) {
          fetchData();
          setmodalChangeProfile(false);
        }
        dispatch(message(response.message));
        setcoinloader(false);
      })
      .catch((e) => {
        dispatch(message(e.message));
        setcoinloader(false);
      });
  };

  const handleImagePreview = (e) => {
    const image_as_files = e.target.files[0];
    setLogo(URL.createObjectURL(e.target.files[0]));
    setFormdata({ ...formdata, profile_img: image_as_files });
  };

  const validateDate = (dateString) => {
    const regex = /^\d{2}-\d{2}-\d{4}$/;
    return regex.test(dateString);
  };

  const handleDateChange = (e, field) => {
    const { value } = e.target;

    if (validateDate(value) || value === "") {
      setFormdata({ ...formdata, [field]: value });
    }
  };

  useEffect(() => {
    if (params.id) {
      setapiloader(true);
      fetchData(params.id);
    }
  }, []);

  return (
    <>
      <ModalPopup
        show={modalChangeProfile}
        size="sm"
        onHide={() => setmodalChangeProfile(false)}
        heading="Change Users Profile Pictures."
      >
        <div>
          <span>Do you really wants to change users Profile Picture?</span>
        </div>
        <form onSubmit={onAddSchool}>
          <Form.Group className="form-group">
            <Form.Label>
              Profile Photo
              {!formdata.id && <span style={{ color: "red" }}>*</span>}
            </Form.Label>
            <Form.Control
              type="file"
              accept=".jpg,.png,.jpeg,.gif"
              required={!formdata.id}
              onChange={handleImagePreview}
            />
            <small>Photo need to be 1029 X 452 pixels.</small>
            {logo && (
              <>
                <img className="preview" src={logo} style={{ width: "auto" }} />
              </>
            )}
            <div className="mt-2 d-flex justify-content-center">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={coinloader}
              >
                {coinloader ? "Please wait..." : "yes"}
              </button>
              <button
                className="btn btn-primary"
                onClick={() => setmodalChangeProfile(false)}
              >
                No
              </button>
            </div>
          </Form.Group>
        </form>
      </ModalPopup>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Social Media</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Platform</Form.Label>
            <Form.Control
              type="text"
              value={modalData.platform}
              onChange={(e) =>
                setModalData({ ...modalData, platform: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Link</Form.Label>
            <Form.Control
              type="text"
              value={modalData.link}
              onChange={(e) =>
                setModalData({ ...modalData, link: e.target.value })
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleModalSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Title name="Board Management - Add" />
      <div className="row">
        <div className="col-lg-6">
          <h4>Board Management</h4>
          <Breadcrumb
            pages={[{ title: "Board Management", link: "board-mamnagement" }]}
            active={`${params.id ? "Edit" : "Add"} Board Manager`}
          />
        </div>
      </div>

      <div className="row">
        {/* <div className="col-lg-12">
                    <div className="card">
                        <p className="card-header">{params.id ? 'Edit' : 'Add'} Board Manager</p>
                        <div className="card-body">
                            {apiloader ?
                                <Loader /> :
                                <form onSubmit={onAddSchool}>

                                    <Form.Group className="form-group">
                                        <Form.Label>Name<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={formdata.name}
                                            onChange={e => setFormdata({ ...formdata, name: e.target.value })}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Designation<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={formdata.designation}
                                            onChange={e => setFormdata({ ...formdata, designation: e.target.value })}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Bio <span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            as="textarea"
                                            rows={4}
                                            value={formdata.bio}
                                            onChange={e => setFormdata({ ...formdata, bio: e.target.value })}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Profile Photo{!formdata.id && <span style={{ color: "red" }}>*</span>}</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept=".jpg,.png,.jpeg,.gif"
                                            required={!formdata.id}
                                            onChange={handleImagePreview}
                                        />
                                        <small>Photo need to be 1029 X 452 pixels.</small>
                                        {logo && <>
                                            <img className="preview" src={logo} style={{ width: 'auto' }} />
                                        </>}
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Social Media Links</Form.Label>
                                        <div className="mb-2">
                                            <button type="button" className="btn btn-secondary" onClick={handleAddNew}>
                                                + Add Social Media
                                            </button>
                                        </div>
                                        <ul className="list-group">
                                            {console.log("formdata.social_media", formdata.social_media)}
                                            {formdata?.social_media && formdata?.social_media?.map((sm, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    <span><strong>{sm.platform}</strong>: {sm.link}</span>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => handleEditClick(index)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleDeleteSocial(index)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </Form.Group>

                                    <Form.Group className="form-group">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Check
                                            type="switch"
                                            checked={formdata.status}
                                            onChange={e => setFormdata({ ...formdata, status: Number(e.target.checked) })}
                                        />
                                    </Form.Group>



                                    <button className="btn btn-primary" type="submit" disabled={loader}>
                                        {loader ? 'Please wait...' : (formdata.id ? 'Update' : 'Submit')}
                                    </button>
                                    <Link className="btn btn-danger" to={'/board-management'}>Cancel</Link>
                                </form>
                            }
                        </div>
                    </div>
                </div> */}
        <div className="row profile-page">
          <div className="col-lg-3">
            <div className="card">
              <p className="card-header">User Profile</p>
              <div className="card-body">
                <div className="user">
                  {apiloader ? (
                    <Loader />
                  ) : (
                    <>
                      <div className="mx-auto user_pic_update">
                        <img src={logo} alt="Profile" />
                        <i
                          className="fas fa-user-edit icon_pic_update cp"
                          title="Update Profile Image."
                          onClick={() => {
                            setmodalChangeProfile(true);
                          }}
                        ></i>
                      </div>

                      <p>{formdata.name}</p>
                      <div className="details">
                        <span>
                          <i className="mdi mdi-account" />
                          {formdata.name ? formdata.name : "-"}
                        </span>

                        <span style={{ display: "flex" }}>
                          <i className="mdi mdi-briefcase" />
                          {formdata.designation ? formdata.designation : "-"}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9">
            <div className="card tabspage">
              {apiloader ? (
                ""
              ) : (
                <Tabs
                  activeKey={key}
                  onSelect={(k) => {
                    window.sessionStorage.setItem("userTabs", k);
                    setKey(k);
                  }}
                >
                  <Tab eventKey="user" title="Member Details">
                    {key == "user" && (
                      <div className="p-4 bg-white rounded shadow-sm">
                        <form onSubmit={onAddSchool}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Name<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={formdata.name}
                              onChange={(e) =>
                                setFormdata({
                                  ...formdata,
                                  name: e.target.value,
                                })
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Designation<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={formdata.designation}
                              onChange={(e) =>
                                setFormdata({
                                  ...formdata,
                                  designation: e.target.value,
                                })
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Bio <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              as="textarea"
                              rows={4}
                              value={formdata.bio}
                              onChange={(e) =>
                                setFormdata({
                                  ...formdata,
                                  bio: e.target.value,
                                })
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Profile Photo
                              {!formdata.id && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept=".jpg,.png,.jpeg,.gif"
                              required={!formdata.id}
                              onChange={handleImagePreview}
                            />
                            <small>Photo needs to be 1029 X 452 pixels.</small>
                            {logo && (
                              <>
                                <img
                                  className="preview"
                                  src={logo}
                                  style={{ width: "auto" }}
                                />
                              </>
                            )}
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>Social Media Links</Form.Label>
                            <div className="mb-2">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleAddNew}
                              >
                                + Add Social Media
                              </button>
                            </div>
                            <ul className="list-group">
                              {formdata?.social_media &&
                                formdata?.social_media?.map((sm, index) => (
                                  <li
                                    key={index}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                  >
                                    <span>
                                      <strong>{sm.platform}</strong>: {sm.link}
                                    </span>
                                    <div className="d-flex gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => handleEditClick(index)}
                                      >
                                        Edit
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() =>
                                          handleDeleteSocial(index)
                                        }
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>Status</Form.Label>
                            <Form.Check
                              type="switch"
                              checked={formdata.status}
                              onChange={(e) =>
                                setFormdata({
                                  ...formdata,
                                  status: Number(e.target.checked),
                                })
                              }
                            />
                          </Form.Group>

                          {/* Start Date */}
                          <Form.Group className="form-group">
                            <Form.Label>Start Date</Form.Label>
                            <DatePicker
                              selected={formdata.start_date}
                              onChange={(date) =>
                                setFormdata({ ...formdata, start_date: date })
                              }
                              dateFormat="yyyy-MM-dd"
                              className="form-control"
                              placeholderText="Select Start Date"
                            />
                          </Form.Group>

                          {/* End Date */}
                          <Form.Group className="form-group">
                            <Form.Label>End Date</Form.Label>
                            <DatePicker
                              selected={formdata.end_date}
                              onChange={(date) =>
                                setFormdata({ ...formdata, end_date: date })
                              }
                              dateFormat="yyyy-MM-dd"
                              className="form-control"
                              placeholderText="Select End Date"
                            />
                          </Form.Group>

                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loader}
                          >
                            {loader
                              ? "Please wait..."
                              : formdata.id
                                ? "Update"
                                : "Submit"}
                          </button>
                          <Link
                            className="btn btn-danger"
                            to={"/board-management"}
                          >
                            Cancel
                          </Link>
                        </form>
                      </div>
                    )}
                  </Tab>
                  <Tab eventKey="note" title="Notes">
                    {key === "note" && <BoardNotes boardMemberId={params.id} />}
                  </Tab>
                  <Tab eventKey="file" title="Files">
                    {key === "file" && <BoardFiles boardMemberId={params.id} />}
                  </Tab>
                  <Tab eventKey="contribution" title="Contributions">
                    {key === "contribution" && (
                      <Contributions boardMemberId={params.id} />
                    )}
                  </Tab>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBoardManager;
